const presetElements = [
  {
    type: 'date',
    element: 'el-date-picker'
  },
  {
    type: 'date-picker',
    element: 'el-date-picker'
  },
  {
    type: 'week',
    element: 'el-date-picker',
    attributes: {
      type: 'week'
    }
  },
  {
    type: 'month',
    element: 'el-date-picker',
    attributes: {
      type: 'month'
    }
  },
  {
    type: 'year',
    element: 'el-date-picker',
    attributes: {
      type: 'year'
    }
  },
  {
    type: 'dates',
    element: 'el-date-picker',
    attributes: {
      type: 'dates'
    }
  },
  {
    type: 'daterange',
    element: 'el-date-picker',
    attributes: {
      type: 'daterange'
    }
  },
  {
    type: 'monthrange',
    element: 'el-date-picker',
    attributes: {
      type: 'monthrange'
    }
  }
]

export default presetElements
